import { CreditCardFilter } from "./credit-card-filter";
import { BankFilter } from "./bank-filter";
import { VirtualWalletFilter } from "./virtual-wallet-filter";

export class InvoiceCashDeskPayment {
  public PaymentAmount : number;
  public  BankFilter: BankFilter;
  public  CreditCardFilter: CreditCardFilter;
  public  CreditCardNumber: string;
  public  Coupon: string;
  public  Dues: string;
  public  CheckNumber: string;
  public TranseferNumber: string;
  public VirtualWalletFilter: VirtualWalletFilter;
  public VirtualWalletTransactionId: string | null;
}
